import React, { FC } from "react";
import type { PaymentOrchestrationForeignExchangeAndGlobalLiquidityProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const PaymentOrchestrationForeignExchangeAndGlobalLiquidity: FC<
  PaymentOrchestrationForeignExchangeAndGlobalLiquidityProps
> = ({ content, cover }) => {
  return (
    <section className="paymentOrchestrationForeignExchangeAndGlobalLiquidity">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={786} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="paymentOrchestrationForeignExchangeAndGlobalLiquidity--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
